var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "yxtbiz-joinlib_search yxtbiz-joinlib_flex yxtbiz-joinlib_flexcenter mb8",
    },
    [
      _c("yxtf-svg", {
        staticStyle: { color: "#c0bfbf" },
        attrs: { width: "20px", height: "20px", "icon-class": "search" },
      }),
      _c("yxtf-input", {
        staticClass: "yxtbiz-joinlib_flex1",
        attrs: {
          readonly: _vm.readonly,
          maxlength: "50",
          placeholder: _vm.$t(
            "pc_biz_lbl_searchplaceholder" /** 请输入搜索内容 */
          ),
          clearable: "",
          size: "medium",
        },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
          },
        },
        model: {
          value: _vm.searchText,
          callback: function ($$v) {
            _vm.searchText = typeof $$v === "string" ? $$v.trim() : $$v
          },
          expression: "searchText",
        },
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }